import { Component, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ApiService } from '../../../app/servicios/api/api.service';
import { AdminFuenteService } from '../../servicios/adminfuentes/AdminFuente.service';
import { fuenteFiviI } from '../../../app/modelos/fuenteFivi.interface';
import { fuenteI } from '../../../app/modelos/fuentes.interface';
import { CargandoService } from 'src/app/plantillas/cargando/cargando.service';
import { AlertasService } from '../../servicios/alertas/alertas.service';
import { histActFuenteI } from 'src/app/modelos/histActFuente.interface';
import { AppServiceService } from '../../servicios/AppService.service';
import { FuenteExcel } from '../../modelos/fuenteExcel';
import { EstadoEntiI } from 'src/app/modelos/estadoEntidad.interface';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-fuentes',
  templateUrl: './fuentes.component.html',
  styleUrls: ['./fuentes.component.css']
})
export class FuentesComponent implements OnDestroy,OnInit {

  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();

  fuentes : fuenteI[];
  fuentesVista : fuenteI[];

  fuenteActivar : fuenteI;
  nuevaActivacionFuente : histActFuenteI;
  EstadoActual : String;
  NuevoEstado : EstadoEntiI;
  hoy: string;
  checkCHV: Boolean;
  checkFIVI: Boolean;
  btnguardar: Boolean;

  histoEntidad : histActFuenteI[];
  page : number;

  @ViewChild('openModalActivar') openModalActivar: ElementRef;
  @ViewChild('closeModalActivar') closeModalActivar: ElementRef;
  @ViewChild('openmodalconfirmar') openmodalconfirmar: ElementRef;
  @ViewChild('cerrarmodalconfirmar') cerrarmodalconfirmar: ElementRef;


  constructor(
    private api:ApiService,
    private loadingService: CargandoService,
    private router:Router,
    private alerta:AlertasService,
    private appService:AppServiceService,
    private adminFuentesService: AdminFuenteService,
    private toastr: ToastrService
    ) { }

  download(){
    /*let dto: Array<FuenteExcel> = new Array<FuenteExcel>();
    for (let i of this.fuentesVista){
      let dat: FuenteExcel = new FuenteExcel();
      dat.nit = i.nit;
      dat.razon = i.nombEntidad;
      dat.operacion = i.operacion.nombre +" "+i.operacion.descripcion;
      dat.departamento = i.depto;
      dat.telefono = i.telefono;
      dat.email = i.email;
      dat.estado = i.idEstado.nombre;
      dto.push(dat);
    }
    this.appService.downloadFile(dto, 'Fuentes_'+new Date());*/

    var workbook = XLSX.utils.book_new();
    var ws1 = XLSX.utils.table_to_sheet(document.getElementById('table2excel22'));
    XLSX.utils.book_append_sheet(workbook, ws1, "Fuentes");
    XLSX.writeFile(workbook, "Fuentes.xlsx");
  }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      responsive: true,
      language:
        {
          "processing": "Procesando...",
          "lengthMenu": "Mostrar _MENU_ registros",
          "zeroRecords": "No se encontraron resultados",
          "emptyTable": "Ningún dato disponible en esta tabla",
          "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
          "infoFiltered": "(filtrado de un total de _MAX_ registros)",
          "search": "Buscar:",
          "loadingRecords": "Cargando...",
          "paginate": {
              "first": "Primero",
              "last": "Último",
              "next": "Siguiente",
              "previous": "Anterior"
          },
          "aria": {
              "sortAscending": ": Activar para ordenar la columna de manera ascendente",
              "sortDescending": ": Activar para ordenar la columna de manera descendente"
          },
          "info": "Mostrando de _START_ a _END_ de _TOTAL_ fuentes"
        }
    };

    this.fuenteActivar = new fuenteI;
    this.nuevaActivacionFuente = new histActFuenteI;

    this.adminFuentesService.todasLasFuentes().subscribe(data=>{
      this.dtTrigger.next();
      this.fuentes = data;
      this.fuentesVista = data;

      for (let fte of this.fuentesVista){
        this.api.getdeptoByCod(fte.depto).subscribe(depto0=>{
          fte.depto = depto0.nombre;
        });
      }
    }, error =>{
      console.log(error);
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  regresarDirectorio(){
    this.router.navigate(['directorio']);
  }

  goNuevafuente(){
    this.router.navigate(['nuevafuente']);
  }

  goEditarfuente(id){
    //console.log(id);
    this.router.navigate(['editarfuente', id]);
  }

  goActivarFuente(fuente){
    let id = fuente.id;
    //console.log(id);
    this.router.navigate(['activar',id]);
  }

  EstadoFuente(fuen: fuenteI){
    this.EstadoActual = fuen.idEstado.id;
    this.btnguardar = false;
    this.nuevaActivacionFuente = new histActFuenteI;
    this.fuenteActivar = fuen;
  }

  iniciaGuardadoActivacion(){
    //this.closeModalActivar.nativeElement.click();
    this.openmodalconfirmar.nativeElement.click();
  }

  cancelarConfirmar(){
    //this.cerrarmodalconfirmar.nativeElement.click();
    this.openModalActivar.nativeElement.click();
  }

  async guardarActivacion(){
    this.btnguardar = false;
    if (this.nuevaActivacionFuente.observacion.length < 20) {
      this.toastr.warning('Obsevación muy corta.', 'Advertencia!');
    }else if (this.nuevaActivacionFuente.observacion.length > 255) {
      this.toastr.warning('Obsevación muy larga.', 'Advertencia!');
    }else{
      if (this.EstadoActual == "1"){
        this.NuevoEstado = new EstadoEntiI;
        this.NuevoEstado.id = "2",
        this.NuevoEstado.nombre = 'Inactivo';
        this.NuevoEstado.descripcion = 'Inactivo';

        this.nuevaActivacionFuente.fuente = this.fuenteActivar;
        this.nuevaActivacionFuente.fecha = new Date().toString();
        this.nuevaActivacionFuente.accion = 'Inactivar';
        this.nuevaActivacionFuente.novedad = 'Inactivo';
        this.nuevaActivacionFuente.usuarioMod = localStorage.getItem('usuario');

        if (this.nuevaActivacionFuente.observacion == "" || this.nuevaActivacionFuente.observacion == null) {
          this.toastr.warning('Debe ingresar una observación.', 'Advertencia!');
        } else {
          this.fuenteActivar.idEstado = this.NuevoEstado;
          this.adminFuentesService.actualizarEstadoFuente(this.fuenteActivar).subscribe(data=>{
            this.api.guardarHistActiv(this.nuevaActivacionFuente).subscribe(data=>{
              this.toastr.success('Fuente inactiva.', 'OK!');
              //this.closeModalActivar.nativeElement.click();
              this.cerrarmodalconfirmar.nativeElement.click();
              this.router.navigate(['fuentes']);
            },error=>{
              console.log(error);
            });
          },error=>{
            console.log(error);
          });
        }
      }
      if (this.EstadoActual == "2"){
        this.NuevoEstado = new EstadoEntiI;
        this.NuevoEstado.id = "1",
        this.NuevoEstado.nombre = 'Activo';
        this.NuevoEstado.descripcion = 'Activo';

        this.nuevaActivacionFuente.fuente = this.fuenteActivar;
        this.nuevaActivacionFuente.fecha = new Date().toString();
        this.nuevaActivacionFuente.accion = 'Activar';
        this.nuevaActivacionFuente.novedad = 'Activo';
        this.nuevaActivacionFuente.usuarioMod = localStorage.getItem('usuario');

        if (this.nuevaActivacionFuente.observacion == "" || this.nuevaActivacionFuente.observacion == null) {
          this.toastr.warning('Debe ingresar una observación.', 'Advertencia!');
        } else {
          this.fuenteActivar.idEstado = this.NuevoEstado;
          this.adminFuentesService.actualizarEstadoFuente(this.fuenteActivar).subscribe(data=>{
            this.api.guardarHistActiv(this.nuevaActivacionFuente).subscribe(data=>{
              this.toastr.success('Fuente activa.', 'OK!');
              //this.closeModalActivar.nativeElement.click();
              this.cerrarmodalconfirmar.nativeElement.click();
              this.router.navigate(['fuentes']);
            },error=>{
              console.log(error);
            });
          },error=>{
            console.log(error);
          });
        }
      }
    }


  }

  histActivacionFuente(fuen: fuenteI){
    this.fuenteActivar = fuen;
    this.api.getHistFuente(fuen.id).subscribe(data=>{
      this.histoEntidad = data.sort((a, b) => b.id - a.id);
    },error=>{
      console.log(error);
    });
  }



}
